'use strict'

var mergeFieldWithErrorsForCustomCheckbox = (function () {
  var fields = $('.custom-checkbox .field_with_errors');
  fields.first().append(fields.not(':first').children());
  fields.not(":first").remove();
});

document.addEventListener('turbolinks:load', mergeFieldWithErrorsForCustomCheckbox);
